export var NEW_RESIDENT = "NEW_RESIDENT";
